import React,{useState} from 'react'
// import HomeLogin from "./Pages/login/Home";
import {BrowserRouter as Router,Switch,Route,Link} from 'react-router-dom';
import axios from "axios"
import ReactMapGl,{Marker,Popup} from "react-map-gl";
import Geocoder from 'react-mapbox-gl-geocoder'
import { Navbar, Nav, Container, Row, Button,FormControl,Form,Col,Toast, Card, Jumbotron} from "react-bootstrap";
import { IoLocationSharp } from "react-icons/io5";
import classes from "./App.module.css";
import news from "./fakenews.json"
// import NewsPage from './Components/NewsPage';


function App() {
    const [viewport,setViewPort]=useState({
      latitude:19.0760,
      longitude:72.8777,
      width:"100vw",
      height:"80vh",
      zoom:10
    });
    const [places,setPlaces] = useState([])
    const [mark,setMark] = useState(false)
    const [showpopup,setShowpopup]=useState(false)
    const [currloc,setCurrloc] = useState({lat:"",lng:""})
    const [select,setSelect]= useState("")
  // const AnyReactComponent = ({ text }) => <div>{text}</div>;
  const  onSelected = (viewport, item) => {
    setViewPort(viewport);
    console.log('Selected: ', item)
    setMark(item)
    setCurrloc({lat:item.center[1],lng:item.center[0]})
    axios.get(`https://places.ls.hereapi.com/places/v1/discover/search?in=${item.center[1]},${item.center[0]};r=1000&q=restaurant&apiKey=QUiR_4fKktOIlI1oczow224IxdZCBUQsfnCIJ98NFO4`)
        .then((response)=>{
          console.log(response);
          setPlaces(response.data.results.items)
        })
        .catch(error =>{
          console.log(error);
        })
}

const callapi=(lat,lng,q,num)=>{
    let url = `https://places.ls.hereapi.com/places/v1/discover/search?in=${lat},${lng};r=1000&q=${q}&apiKey=QUiR_4fKktOIlI1oczow224IxdZCBUQsfnCIJ98NFO4`
    axios.get(url)
    .then((response)=>{
      console.log(response);
      setPlaces(response.data.results.items)
    })
    .catch(error =>{
      console.log(error);
    })
}

const queryParams = {
  country: 'in'
}
const getloc =()=>{
    navigator.geolocation.getCurrentPosition(pos =>{
      setCurrloc({lat: pos.coords.latitude, lng: pos.coords.longitude})
      console.log(currloc);
  })
}
  return (
    <div className="App" classname={classes.BackGround} onMouseEnter={getloc}>
      <Jumbotron className={classes.Jumbo}>
        <div style={{backgroundColor:"rgba(255,255,255,0.6)", height:"100%",alignItems:"center"}}>
          <div style={{height:"50px"}}></div>
          <h1>Welcome to Explorer App !!</h1>
          <p>
            Search for Outing Places like Restaurant, Coffee Shop, Shopping Malls etc.
          </p>
          <p>
          <Container>
          {/* <Form.Control
            as="select"
            className="mr-sm-2"
            id="inlineFormCustomSelect"
            style={{width:"200px"}}
            onChange={(e)=>{
              setSelect(e.target.value)
              console.log(select)
            }}
          >
            <option value="0">Choose...</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </Form.Control> */}
          </Container>
            <Button href="#map" variant="primary">Go to map</Button>
          </p>
        </div>
      </Jumbotron>
            <br/>
            <div align="center">
              <h2>Quick Picks</h2>
              <hr style={{width:"150px",height:"2px",color:"white",backgroundColor:"black",borderRadius:"15%"}} />
            </div>
            <br/>
            <Container >
            <Row>
              <Col md={2} lg={4}>
                <Link to="/restaurant">
              <Card className={classes.smLink}>
                <Card.Img variant="top" style={{height:"200px",borderRadius:"15px"}} src="https://static.toiimg.com/photo/51076300/.jpg" />
                <Card.Body>
                  <Card.Title><i>Restrauants</i> </Card.Title>
                  <Card.Text style={{height:"50px"}}>
                    Want To have something Plesent
                  </Card.Text>
                </Card.Body>
              </Card>
              </Link>
              </Col>
              <Col md={2} lg={4}>
            <Link to="/malls">
              <Card className={classes.smLink} >
                <Card.Img variant="top" style={{height:"200px",borderRadius:"15px"}} src="https://researchmatters.in/sites/default/files/styles/large_800w_scale/public/mal_iitb_0.jpg?itok=VoI6E0oB" />
                <Card.Body>
                  <Card.Title><i>Places to Visit</i></Card.Title>
                  <Card.Text style={{height:"50px"}}>
                    Grab something on the go or just to have an experience
                  </Card.Text>
                </Card.Body>
              </Card>
              </Link>
              </Col>
              <Col md={2} lg={4}>
            <Link to="/news">
              <Card className={classes.smLink} >
                <Card.Img variant="top" style={{height:"200px",borderRadius:"15px"}} src="https://img.etimg.com/thumb/msid-74938928,width-300,imgsize-193300,,resizemode-4,quality-100/untitled-14.jpg" />
                <Card.Body>
                  <Card.Title><i>News</i></Card.Title>
                  <Card.Text style={{height:"50px"}}>
                    Some quick findings of what's going on nearby
                  </Card.Text>
                </Card.Body>
              </Card>
              </Link>
              </Col>
            </Row>
          </Container>
          <br/>
          <br id="map"/>
      <ReactMapGl {...viewport} 
      mapboxApiAccessToken="pk.eyJ1IjoiYnJlbmRhbmx1Y2FzIiwiYSI6ImNrbWhoYmxhZDA3ZHYyd2s1Mm8zcXU5b3kifQ.xFkPXRpxh3rJUuPqog7dpA" 
      mapStyle="mapbox://styles/mapbox/satellite-streets-v11"
      // "mapbox://styles/mapbox/satellite-v9"
      onViewportChange = {viewport =>{
        setViewPort(viewport);
      }}
      >
       {mark&&
       <Marker
       latitude={mark.geometry.coordinates[1]}
       longitude={mark.geometry.coordinates[0]}
       >
         <IoLocationSharp style={{color:"#ff0000", fontSize:"2.5em"}} onClick={(e)=>{
           e.preventDefault()
           setShowpopup(mark)
         }} />
        </Marker>}

        {places&&places.map(place=>{
            return(
            <Marker
            latitude={place.position[1]?place.position[1]:0}
            longitude={place.position[0]?place.position[0]:0}
            >
              <IoLocationSharp style={{color:"#0000ff", fontSize:"5.5em"}} onClick={(e)=>{
                e.preventDefault()
                setShowpopup(mark)
              }} />
             </Marker>
            )
        })
       }

        {showpopup&&<Popup latitude={showpopup.geometry.coordinates[1]} longitude={showpopup.geometry.coordinates[0]} onClose={()=>{setShowpopup(false)}}>
          <div>
              <h5>{showpopup.place_name}</h5>
              <h6>{showpopup.properties.category}</h6>
          </div>
        </Popup>
        }
      </ReactMapGl>
        <br/>
        <Container>
          <Row>
            <Col md={6}>
            <div align="center">
                <h3>Search for Places</h3>
                <div style={{backgroundColor:"white",borderRadius:"25px"}}>
                <Geocoder
                  mapboxApiAccessToken="pk.eyJ1IjoiYnJlbmRhbmx1Y2FzIiwiYSI6ImNrbWhoYmxhZDA3ZHYyd2s1Mm8zcXU5b3kifQ.xFkPXRpxh3rJUuPqog7dpA" 
                  onSelected={onSelected} 
                  viewport={viewport} 
                  hideOnSelect={true}
                  queryParams={queryParams}
                //   className={classes.Searchbar}
              />
              </div>
              <br/>
                <Button  type="primary">Search</Button>
            </div>
            </Col>
            <Col md={6}>
            <h2>Places to visit nearby</h2>
            {places && places.slice(0,5).map((item,index)=>{
              return(
                <Card key={index} style={{marginBottom:"10px"}}>
                <Card.Header closeButton={false}>
                  <strong className="mr-auto">{item.category.title}</strong>
                </Card.Header>
                <Card.Body>
                  <img src={item.icon} /><strong>{item.title}</strong>
                  <br/><br/>
                  {item.openingHours&&item.openingHours.text}
                  <br/>
                  <br/>
                  {item.openingHours&&item.openingHours.isOpen? "Open Now": "Closed"}
                </Card.Body>
              </Card>
              )
            })}
            </Col>
          </Row>
        </Container>
    </div>
  )
}

export default App

